import { User } from '../models/all';

export function isProfileComplete(user: Partial<User> | null): boolean {
  if (!user) return false;
  const required: (keyof User)[] = [
    'legalName',
    'phone',
    'address',
    'city',
    'state',
    'pincode',
    'birthdate',
  ];
  return required.every((field) => Boolean((user as any)[field]));
}
